import { Action } from '@ngrx/store';
import { IProjectTask } from '../../../../commons';

export enum ProjectTaskActionTypes {
  LoadProjectTaskState = '[ProjectTask] Load ProjectTask State',
  LoadProjectTaskStateSuccess = '[ProjectTask] Load ProjectTask State Success',
  LoadProjectTaskStateFail = '[ProjectTask] Load ProjectTask State Fail',
  ProjectTaskScreenErrorReset = '[ProjectTask] ProjectTask Screen Error Reset'

}

export class LoadProjectTaskState implements Action {
  readonly type = ProjectTaskActionTypes.LoadProjectTaskState;
}

export class LoadProjectTaskStateSuccess implements Action {
  readonly type = ProjectTaskActionTypes.LoadProjectTaskStateSuccess;
  constructor(public payload: IProjectTask ) {}
}

export class LoadProjectTaskStateFail implements Action {
  readonly type = ProjectTaskActionTypes.LoadProjectTaskStateFail;
  constructor(public payload: any) {}
}

export class ProjectTaskScreenErrorReset implements Action {
  readonly type = ProjectTaskActionTypes.ProjectTaskScreenErrorReset;
}

export type ProjectTaskActions = 
  LoadProjectTaskState
  | LoadProjectTaskStateSuccess
  | LoadProjectTaskStateFail
  | ProjectTaskScreenErrorReset;